import type { State } from 'types';
import { StakingState } from 'types/store/staking';

export default {
  getStakingState: (state: State): StakingState => state.staking,
};
